import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import apex from '../../apex';
import { callAPI } from './apiActions';
import { showSnack } from './snackbarActions';
import { formatErrorText } from '../../helpers/errorTextFormatter';
import { MODAL_TYPES, openModal, closeModal } from './modalActions';
import { closeSidePane } from './sidePaneActions';
export var GET_TRANSFERS_REQUESTED = 'GET_TRANSFERS_REQUESTED';
export var GET_TRANSFERS_RECEIVED = 'GET_TRANSFERS_RECEIVED';
export var GET_INCOMING_TRANSFERS = 'GET_INCOMING_TRANSFERS';
export var TRANSFER_REQUEST_SUCCEEDED = 'TRANSFER_REQUEST_SUCCEEDED';
export var getTransfers = function getTransfers(AccountId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var OMSId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestTransfers());
              OMSId = getState().user.userInfo.OMSId;
              _context.next = 4;
              return dispatch(callAPI('GetTransfers', {
                OMSId: OMSId,
                AccountId: AccountId
              })).then(function (res) {
                dispatch(receiveTransfers(res));
              });
            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getIncomingTransfers = function getIncomingTransfers(OMSId, AccountId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', dispatch(callAPI('GetTransfersReceived', {
                OMSId: OMSId,
                AccountId: AccountId
              })).then(function (res) {
                return dispatch(receiveIncomingTransfers(res));
              }));
            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var requestTransferFunds = function requestTransferFunds(payload) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var OMSId, response, snackbarPayload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              _context3.next = 3;
              return dispatch(callAPI('RequestTransferFunds', Object.assign({
                OMSId: OMSId
              }, payload)));
            case 3:
              response = _context3.sent;
              snackbarPayload = response.result ? {
                id: 'requestTransferSuccess',
                // context.t('Request transfer succeeded');
                text: 'Request transfer succeeded',
                type: 'success'
              } : {
                id: 'requestTransferError',
                text: formatErrorText(response),
                type: 'warning'
              };
              dispatch(showSnack(snackbarPayload));
            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var transferFunds = function transferFunds(payload, pane) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _getState$user, SenderAccountId, OMSId, response, snackbarPayload;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState$user = getState().user, SenderAccountId = _getState$user.selectedAccountId, OMSId = _getState$user.userInfo.OMSId;
              _context4.next = 3;
              return dispatch(callAPI('TransferFunds', Object.assign({
                OMSId: OMSId,
                SenderAccountId: SenderAccountId
              }, payload)));
            case 3:
              response = _context4.sent;
              snackbarPayload = response.result ? {
                id: 'transferSuccess',
                // context.t('Transfer succeeded');
                text: 'Transfer succeeded',
                type: 'success'
              } : {
                id: 'transferError',
                text: formatErrorText(response),
                type: 'warning'
              };
              dispatch(closeSidePane(pane));
              dispatch(showSnack(snackbarPayload));
            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var receiveIncomingTransfers = function receiveIncomingTransfers(payload) {
  return {
    type: GET_INCOMING_TRANSFERS,
    payload: payload
  };
};
export var receiveTransfers = function receiveTransfers(payload) {
  return {
    type: GET_TRANSFERS_RECEIVED,
    payload: payload
  };
};
export var requestTransfers = function requestTransfers() {
  return {
    type: GET_TRANSFERS_REQUESTED
  };
};
export var requestTransferSucceeded = function requestTransferSucceeded(payload) {
  return {
    type: TRANSFER_REQUEST_SUCCEEDED,
    payload: payload
  };
};
export var sendTwoFactorAuthCodeForTransfers = function sendTwoFactorAuthCodeForTransfers(code) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var auth;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return apex.connection.Authenticate2FA({
                Code: code
              });
            case 2:
              auth = _context5.sent;
              if (auth.Authenticated) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt('return', auth);
            case 5:
              dispatch(closeModal(MODAL_TYPES.SEND_REQUEST_2FA));
              dispatch(closeSidePane());
              dispatch(showSnack({
                id: 'transferSuccess',
                // context.t('Transfer succeeded');
                text: 'Transfer succeeded',
                type: 'success'
              }));
            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};